import { ReactElement } from "react";
import { LiveChatProps } from "@twiliointernal/org/twilio/e2-commons/shared/definitions";

import useConversationSetup from "../../hooks/useConversationSetup";

const LiveChat = (props: LiveChatProps): ReactElement => {
  const { currentAgent, messages, sdkError, isReady } =
    useConversationSetup(props);

  return (
    <div>
      <h1>Live Chat</h1>
      {sdkError && <p>{sdkError}</p>}
      {!sdkError && (!isReady ? <p>Loading...</p> : <p>Ready!</p>)}
      {currentAgent && <p>Agent: {currentAgent.name}</p>}
      <p>Messages:</p>
      <ul>
        {messages.map((message) => (
          <li key={message.sid}>{message.body}</li>
        ))}
      </ul>
    </div>
  );
};

export default LiveChat;
